import React, { useEffect, useState } from 'react';
import TileBlock from '../tile-block/tile-block';
import { ProcessHitsIntoTilesProps } from './automated-listing-tile-block.types';
import { TileProps } from '@components/tile/tile.types';

const processHitsIntoTiles = ({
  hits,
  locale,
}: ProcessHitsIntoTilesProps): TileProps[] => {
  return hits.map(hit => {
    return {
      renderType: 'standard',
      tileType: 'standard',
      id: hit.objectID,
      tileGeography: hit.geography,
      url: hit.url,
      contentType: hit.pageType,
      title: hit.listingTitle,
      description: hit.listingDescription ? hit.listingDescription : '',
      imageUrl: hit.file ? hit.file.url : '',
      imageAlt: hit.entryTitle,
      tags: hit.topics,
      localeCode: locale,
      tileUpdatedAt: hit.dateCreated,
      resourceContentType: hit.resourceContentType?.map(r => r.title),
    };
  });
};

export function SearchResultTiles({
  searchResults,
  searching,
  locale,
  tileBlockProps,
}) {
  const {
    title,
    anchorId,
    description,
    cta,
    numberOfTiles,
    manualTilesOverwritten,
    pageColour,
  } = tileBlockProps;

  const [tilesData, setTilesData] = useState<TileProps[]>([]);

  useEffect(() => {
    if (searchResults) {
      let processedTiles = processHitsIntoTiles({
        hits: searchResults._rawResults[0].hits,
        locale: locale,
      });

      processedTiles = [...manualTilesOverwritten, ...processedTiles];
      processedTiles.splice(numberOfTiles);

      setTilesData(processedTiles);
    }
  }, [locale, manualTilesOverwritten, numberOfTiles, searchResults]);

  return (
    <div data-testid="automated-tiles-list">
      {searching ? null : (
        <TileBlock
          tiles={tilesData}
          title={title}
          anchorId={anchorId}
          description={description}
          cta={cta}
          colour={pageColour}
          {...tileBlockProps}
        />
      )}
    </div>
  );
}
